import React from "react";
import Navbar from "../../shared/ui/Navbar/Navbar";
import { useAuth } from "../../shared/hooks/useAuth";
import { getBookId } from "../../shared/lib/localStorage";
import { useInvoice } from "./hooks/useInvoice";

interface Props {
  faqDesc?: any;
}

export const SiteHeader: React.FunctionComponent<Props> = ({
  faqDesc,
}: Props) => {
  const { token } = useAuth();
  let bookId: any = getBookId();
  const { fetchGenerateLink } = useInvoice(bookId as string);

  return <Navbar faqDesc={faqDesc} fetchGenerateLink={fetchGenerateLink} token={token}/>;
};
